import styled from 'styled-components'
import Browser from '../../../../../services/Browser'
import { breakpoints } from '../../../../../constants'

export const StyledForm = styled.form`
	display: ${Browser.isInternetExplorer() ? 'flex' : 'grid'};
	grid-gap: 4rem 15px;
	margin-bottom: 4rem;
	justify-content: ${Browser.isInternetExplorer() ? 'space-between' : ''};
	flex-wrap: wrap;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		grid-template-columns: repeat(5, 1fr);
	}

	& > * {
		width: ${Browser.isInternetExplorer() ? '190px' : null};
		margin: ${Browser.isInternetExplorer() ? '0 15px 4rem 0' : null};
	}

	& > :last-child {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-row: 2 / span 1;
			grid-column: 5;
			margin-left: ${Browser.isInternetExplorer() ? '0px' : null};
			${Browser.isInternetExplorer()
				? 'position: relative; left: 80%;'
				: ''};
		}
	}
	.buttons {
		grid-column: 4;
		display: flex;
		grid-column-end: none;

		button:first-child {
			padding-left: 25px;
			padding-right: 25px;
			max-width: unset !important;
		}

		button:last-child {
			margin-left: 10px;
		}
	}
	.exportar {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-column: 4;
			margin-left: ${Browser.isInternetExplorer() ? 'auto' : null};
		}
	}
`
export const BpeDiv = styled.div`
	display: flex;
	align-items: flex-start;
	margin: 4px 0px;

	span:first-child {
		flex: 1;
		min-width: 0;
		word-break: break-all;
	}

	.fa-copy {
		flex-shrink: 0;
		margin-left: 10px;
		margin-top: 3px;
	}

	a {
		margin-left: 10px;
	}
`
